const listaCategoria = 
    {   "-100":"pollos.png",
        "-105":"pipocas.png",
        "-104":"promocion.png",
        "-103":"extras.png",
        "-102":"helados.png",
        "-101":"jugos.png",
    }

export default listaCategoria;